<template>
    <el-container style="height: 100%">
        <el-main style="height: 100%">
            <!-- 顶部：说明与统计 -->
            <div class="ilink-toolbar">
                <span class="ilink-title">知识图谱</span>
                <span v-if="stats" class="ilink-stats">
                    文档 {{ stats.nodeCount }} · 关联 {{ stats.linkCount }}
                </span>
            </div>

            <div v-loading="loading" class="ilink-chart-box">
                <div id="ilinkChart" class="ilink-chart"></div>
                <el-empty v-if="!loading && isEmpty" description="暂无可展示的文档关系" />
            </div>
        </el-main>
    </el-container>
</template>

<script>
import request from '@/utils/request';

export default {
    name: 'Ilink',
    data() {
        return {
            loading: false,
            isEmpty: false,
            stats: null,
            chart: null
        };
    },
    mounted() {
        document.title = 'Hidoc-知识图谱';
        this.loadGraph();
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    methods: {
        handleResize() {
            if (this.chart) {
                this.chart.resize();
            }
        },
        loadGraph() {
            this.loading = true;
            this.isEmpty = false;
            return request({
                url: '/openapi/collected/ilinkRelationAll',
                method: 'post',
                data: {}
            }).then(res => {
                this.loading = false;
                if (res.code === 0 && res.meta) {
                    const datas = res.meta.datas || [];
                    const links = res.meta.links || [];
                    const categories = res.meta.categories || [];
                    this.stats = { nodeCount: datas.length, linkCount: links.length };
                    if (datas.length === 0) {
                        this.isEmpty = true;
                        return;
                    }
                    this.renderChart(datas, links, categories);
                } else {
                    this.isEmpty = true;
                }
            }).catch(() => {
                this.loading = false;
                this.isEmpty = true;
            });
        },
        renderChart(datas, links, categories) {
            if (this.chart) {
                this.chart.dispose();
            }
            this.chart = this.$echarts.init(document.getElementById('ilinkChart'));

            const palette = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#48b3bd', '#c1232b', '#27727b', '#bda29a', '#6e7074', '#546570', '#c4ccd3', '#f9a825', '#d81b60', '#00897b', '#5e35b1'];

            const option = {
                animationDurationUpdate: 500,
                animationEasingUpdate: 'quinticInOut',
                color: palette,
                tooltip: {
                    formatter: function (param) {
                        if (param.dataType === 'node') {
                            return param.data.name;
                        }
                        return '';
                    }
                },
                series: [
                    {
                        type: 'graph',
                        layout: 'force',
                        focusNodeAdjacency: false,
                        draggable: true,
                        symbolSize: 12,
                        roam: true,
                        edgeSymbol: ['circle', 'arrow'],
                        edgeSymbolSize: [2, 8],
                        edgeLabel: {
                            show: false
                        },
                        emphasis: {
                            focus: 'none',
                            scale: false
                        },
                        blur: {
                            itemStyle: { opacity: 1 },
                            lineStyle: { opacity: 1 },
                            label: { opacity: 1 }
                        },
                        force: {
                            layoutAnimation: true,
                            gravity: 0.02,
                            edgeLength: 60,
                            repulsion: 100
                        },
                        lineStyle: {
                            width: 1,
                            color: 'target',
                            curveness: 0.2,
                            type: 'solid'
                        },
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{b}',
                            textStyle: {
                                fontSize: 12,
                                fontWeight: 400,
                                color: '#666'
                            }
                        },
                        data: datas,
                        links: links,
                        categories: categories
                    }
                ]
            };
            this.chart.setOption(option);

            const that = this;
            this.chart.on('click', function (param) {
                if (param.dataType === 'node') {
                    const routeData = that.$router.resolve({
                        name: 'collected',
                        params: { collectedId: param.data.collectedId, docId: param.data.docId }
                    });
                    window.open(routeData.path, '_blank');
                }
            });
        }
    }
};
</script>

<style scoped>
.ilink-toolbar {
    margin-bottom: 12px;
    display: flex;
    align-items: baseline;
    gap: 12px;
}
.ilink-title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
}
.ilink-stats {
    font-size: 13px;
    color: #909399;
}
.ilink-chart-box {
    position: relative;
    width: 100%;
    height: calc(100vh - 120px);
    min-height: 600px;
}
.ilink-chart {
    width: 100%;
    height: 100%;
}
</style>
